// Calculator widths
export default {
    SMALL: '50rem', // or use rh-max-width-50
    LARGE: '75rem', // or use rh-max-width-75 - (1200px) Ratehub.ca full page content width
};
